import React, { Fragment, useEffect } from 'react';
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from 'react-router-dom';
import ErrorPage from '../../components/templates/ErrorPage';
import { IMainTemplate } from '../../models';
import BottomMenu from './components/bottomMenu/bottomMenu';
import MenuBar from './components/menuBar';

const Template: React.FC<IMainTemplate> = ({ children }) => {
  const { pathname } = useLocation();

  const showMenu = () => {
    return true;
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);


  const ErrorFallback = () => {
    return <ErrorPage />
  };

  const logError = (error: any) => {
    console.log('error', error);
  };

  return (
    <ErrorBoundary
      onError={logError}
      FallbackComponent={ErrorFallback}
    >
      <div className="flex min-h-screen flex-col">
        <div className="fixed top-0 z-10 w-full">
          <MenuBar />
        </div>
        {showMenu() ? (
          <Fragment>
            <div
              className={`mt-16 min-h-[calc(100vh-64px)] w-full bg-color-lighter 
            ${!pathname.includes('/exercicio/') ? 'mb-[70px]' : ''} lg:mb-0 xs:px-4 md:px-8 lg:px-[82px]`}
            >
              {children}
            </div>

            <div className="fixed bottom-0 z-10 w-full">
              <BottomMenu />
            </div>
          </Fragment>
        ) : (
          <div className="mt-12 min-h-screen w-full bg-color-lighter md:mb-0 xs:mx-4 md:mx-8">
            {children}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default Template;
